export enum UserRoleEnum {
  ADMIN = 1,
  USER = 2
}
